import { RoleAccessesModel } from '../models/role-accesses.model';
import RequestCreator from './helpers/requestCreator';

class RoleAccesses extends RequestCreator<RoleAccessesModel> {}

const api = new RoleAccesses('/role-accesses');
export default api;
